'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.navigation');
  const menuToggle = document.querySelector('.header__navigation-toggle');
  const btnSubmenuOpen = document.querySelectorAll('.navigation__button');
  const btnSubmenuClose = document.querySelectorAll('.navigation__back');
  const menuTitle = document.querySelectorAll('.navigation__text');

  if(menu) {
    menuToggle.addEventListener('click', () => {
      document.body.classList.toggle('no-scroll');
      menu.classList.toggle('navigation--opened');
      menuToggle.classList.toggle('header__navigation-toggle--opened');
      return false;
    });

    if (menuTitle) {
      menuTitle.forEach((item) => {
        let parentItem = item.parentElement.parentElement.parentElement.parentElement.parentElement;
        if (parentItem.closest('.navigation__dropdown')) {
          let text = parentItem.querySelector('.navigation__link').innerText;
          item.querySelector('span').innerText = text[0] + text.slice(1)
          .toLowerCase();
        }
      });
    }

    window.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && menu.closest('.navigation--opened')) {
        menu.classList.remove('navigation--opened');
        menuToggle.classList.remove('header__navigation-toggle--opened');
      }
    });

    menu.addEventListener('transitionend', (e) => {
      if (!menu.closest('.navigation--opened') && e.propertyName === 'transform') {
        document.body.classList.remove('no-scroll');
      }
    });

    btnSubmenuOpen.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.nextElementSibling.classList.add('hierarchical--opened');
      })
    });

    btnSubmenuClose.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.parentElement.parentElement.classList.remove('hierarchical--opened');
      })
    });

    let widthWindow = window.outerWidth;
    window.addEventListener('resize', () => {
      if (widthWindow !== window.outerWidth) {
        document.body.classList.remove('no-scroll');
        menu.classList.remove('navigation--opened');
        menuToggle.classList.remove('header__navigation-toggle--opened');
        document.querySelectorAll('.hierarchical')
        .forEach((item) => item.classList.remove('hierarchical--opened'));
      }
    });
  }
});
